import { render, staticRenderFns } from "./IconLockClosed.vue?vue&type=template&id=8573bd02&"
import script from "./IconLockClosed.vue?vue&type=script&lang=js&"
export * from "./IconLockClosed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports